export const BUILTIN_ALIASES: Record<string, string> = {
    la: "ls -h",
    lah: "ls -lh",
    cls: "clear",
    menu: "ls",
    more: "cat",
    h: "cat help.txt",
};

export function expandAlias(
    input: string,
    vfsAliases: Record<string, string> = {},
): string | null {
    const trimmed = input.trim();
    if (!trimmed) return null;

    const [cmd, ...args] = trimmed.split(/\s+/);
    const target = vfsAliases[cmd!.toLowerCase()] ?? BUILTIN_ALIASES[cmd!.toLowerCase()];
    if (!target) return null;

    if (args.length === 0) {
        return target;
    }

    if (!target.includes(" ")) {
        return `${target} ${args.join(" ")}`;
    }

    return null;
}

const SECTION_PAGE_CATS = /^cat (about|certs|projects|games|contact)\.txt$/i;

export function isSectionPageCat(command: string): boolean {
    return SECTION_PAGE_CATS.test(command.trim());
}
